import React from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { PAGE_TABS } from 'components/VisitRecords/VisitRecords';
import SymptomView from 'components/SymptomView/SymptomView';
import { visitTypes } from '../../context/visitContext';
import { usePatient } from '../../context/appContext';

function VisitSymptoms() {
  const [showNextButton, setShowNextButton] = React.useState(false);
  const { patient } = usePatient();
  const { visitId = '' } = useParams<{ visitId: string }>();
  const navigate = useNavigate();
  const location = useLocation();
  const params = new URLSearchParams(location.search);

  const visitType = params.get('type');

  const visit = visitTypes.find(fndVisit => fndVisit.type === visitType?.toLocaleUpperCase());

  if (!visit) {
    throw new Error(
      visitType
        ? `Error displaying health history for ${visitType} visit`
        : `Error displaying health history for unknown visit.`,
    );
  }

  // Let filter and view detailed information of the opened questionnaire.
  const questionnaires = (patient?.questionnaires || []).filter(
    fndQuestionnaire => fndQuestionnaire.id === visitId,
  );

  const handleNextTab = () => {
    const tab = 'symptoms';

    const indexOfActiveTab = PAGE_TABS.findIndex(fndTab => fndTab.id === tab);

    const nextTab = PAGE_TABS.find((_, index) => index === indexOfActiveTab + 1);

    if (nextTab) {
      const tabURL = `${location.pathname.replace(tab, nextTab.id)}${location.search}`;
      navigate(tabURL);
    }
  };

  return (
    <div className="flex flex-col pt-0 pb-10 tablet:pt-6 tablet:pb-7">
      <SymptomView
        visitId={visitId}
        visit={visit}
        questionnaires={questionnaires}
        onDoneLoading={() => setShowNextButton(true)}
      />

      {showNextButton && (
        <button
          type="button"
          onClick={() => handleNextTab()}
          className="w-fit border border-river-blue text-river-blue rounded-full px-5 py-[8px] text-sm mt-6 min-w-[180px] 
            hover:bg-[#EEFBFF]"
        >
          Next
        </button>
      )}
    </div>
  );
}

export default VisitSymptoms;
